export { default as AlmacenVer } from  './Ver'
export { default as AlmacenesList } from './Listar'
export { default as AlmacenSalida } from  './Salida'
